import {
	ConstructionSiteAnalysisData,
	SupportingDocumentsAnalysis,
} from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { constructionSiteAnalysisQueryKeys } from "../query-keys/constructionSiteAnalysis.query-keys";

export const getConstructionSiteAnalysisData = async (
	constructionSiteId: number,
): Promise<ConstructionSiteAnalysisData> => {
	const { data } = await privateAxios.get<ConstructionSiteAnalysisData>(
		`/construction-sites-submission/${constructionSiteId}/analysis-data`,
	);
	return data;
};

export const useGetConstructionSiteAnalysisData = (
	constructionSiteId: number,
) => {
	return useQuery({
		queryKey:
			constructionSiteAnalysisQueryKeys.analysisData(constructionSiteId),
		queryFn: () => getConstructionSiteAnalysisData(constructionSiteId),
		enabled: !!constructionSiteId,
	});
};

export const getSupportingDocumentsAnalysis = async (
	constructionSiteId: number,
): Promise<SupportingDocumentsAnalysis> => {
	const { data } = await privateAxios.get<SupportingDocumentsAnalysis>(
		`/construction-sites-submission/${constructionSiteId}/supporting-documents-analysis`,
	);
	return data;
};

export const useGetSupportingDocumentsAnalysis = (
	constructionSiteId: number,
	enabled = true,
) => {
	return useQuery({
		queryKey: [
			...constructionSiteAnalysisQueryKeys.analysisData(constructionSiteId),
			"supporting-documents-analysis",
		],
		queryFn: () => getSupportingDocumentsAnalysis(constructionSiteId),
		enabled: !!constructionSiteId && enabled,
	});
};

export const getReceptionSupportingDocumentsAnalysis = async (
	constructionSiteId: number,
): Promise<SupportingDocumentsAnalysis> => {
	const { data } = await privateAxios.get<SupportingDocumentsAnalysis>(
		`/construction-sites-reception/${constructionSiteId}/supporting-documents-analysis`,
	);
	return data;
};

export const useGetReceptionSupportingDocumentsAnalysis = (
	constructionSiteId: number,
	enabled = true,
) => {
	return useQuery({
		queryKey: [
			...constructionSiteAnalysisQueryKeys.analysisData(constructionSiteId),
			"reception-supporting-documents-analysis",
		],
		queryFn: () => getReceptionSupportingDocumentsAnalysis(constructionSiteId),
		enabled: !!constructionSiteId && enabled,
	});
};
